import { html } from 'lit';
export const jvLogo = () => html `<span class="inline-flex items-center gap-2">
  <span class="grid place-items-center w-8 h-8 rounded-xl bg-jv-primary text-white shadow-jv">
    <svg viewBox="0 0 24 24" class="w-5 h-5" fill="none" stroke="currentColor"
         stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7S2 12 2 12z"/>
      <circle cx="12" cy="12" r="3"/>
    </svg>
  </span>
  <span class="font-extrabold text-jv-ink text-lg tracking-tight">
    Just<span class="text-jv-primary">Vue</span>
  </span>
</span>`;
